import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Sunrise, Sunset, TrendingUp, TrendingDown, Thermometer } from "lucide-react";

/**
 * Compact "coastal conditions" strip: sunrise/sunset + water temp + next high/low tide.
 * Data fetched from backend which proxies Open-Meteo (free, no API key).
 * Rendered in the Home hero, over the beach photo — glass-morphism style.
 */
export default function CoastalConditions() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/whitsundays/conditions").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;

  const chips = [
    d.sunrise    && { Icon: Sunrise,      label: "Sunrise",   value: d.sunrise },
    d.sunset     && { Icon: Sunset,       label: "Sunset",    value: d.sunset },
    d.water_temp && { Icon: Thermometer,  label: "Water",     value: `${d.water_temp}°C` },
    d.next_high_tide && { Icon: TrendingUp,   label: "High tide", value: d.next_high_tide.time },
    d.next_low_tide  && { Icon: TrendingDown, label: "Low tide",  value: d.next_low_tide.time },
  ].filter(Boolean);

  if (!chips.length) return null;

  return (
    <div
      className="mt-8 inline-flex flex-wrap items-center gap-x-6 gap-y-2 px-5 py-3 rounded-full bg-white/12 backdrop-blur border border-white/20 text-white/95 text-sm"
      data-testid="coastal-conditions"
    >
      {chips.map(({ Icon, label, value }) => (
        <span key={label} className="inline-flex items-center gap-1.5" data-testid={`condition-${label.toLowerCase().replace(/\s+/g, '-')}`}>
          <Icon className="w-4 h-4 text-sponsored" strokeWidth={1.75} />
          <span className="text-white/70 text-xs uppercase tracking-widest">{label}</span>
          <span className="font-medium">{value}</span>
        </span>
      ))}
    </div>
  );
}
